import { useEffect, useState } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@store';
import { Device } from '../../types';
import {
  useEndCustomerSessionMutation,
  useLazyGetCustomerDeviceSessionsQuery,
} from '../../store/services/individual';
import { clearDeviceState } from '../../store/slices/devices';

import ROUTES from '../../../../routes';

const useDeviceForm = ({
  customerId,
  deviceId,
  devices,
}: {
  customerId?: string;
  deviceId?: string;
  devices?: Device[];
}) => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [device, setDevice] = useState<Device | undefined>(undefined);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [endSession, { isLoading, isSuccess }] =
    useEndCustomerSessionMutation();

  const [
    getDeviceSessions,
    { isLoading: deviceSessionsIsLoading, isFetching },
  ] = useLazyGetCustomerDeviceSessionsQuery();

  const handleClose = () => {
    setPanelIsOpen(false);
    setDevice(undefined);
    dispatch(clearDeviceState());

    setTimeout(() => {
      navigate(
        generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_DEVICES, {
          customerId: customerId as string,
        }),
      );
    }, 100);
  };

  const onLinkClick = () => {
    dispatch(clearDeviceState());
  };

  useEffect(() => {
    if (deviceId && devices) {
      const currentDevice = devices?.find((item) => item.id === deviceId);

      if (currentDevice) {
        setDevice(currentDevice);
      }
    }
  }, [deviceId, devices]);

  useEffect(() => {
    setPanelIsOpen(true);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      handleClose();
    }
  }, [isSuccess]);

  return {
    panelIsOpen,
    handleClose,
    isLoading,
    endSession,
    device,
    onLinkClick,
    isFetching,
    deviceSessionsIsLoading,
    getDeviceSessions,
  };
};

export default useDeviceForm;
